/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import Component from 'can/component/component';
import template from './tooltip-container.stache';

Component.extend({
    tag: 'tooltip-container',
    template: template,
    viewModel: {
        define: {
            isActive: {
                type: 'boolean',
                value: false,
            },
            text: {
                type: 'string',
                value: '',
            },
        },
        show() {
            const { left, top } = this.icon.offset();
            const tooltipEl = this.element.find('#tooltipContainer');
            const offsetLeft = getOffsetLeft(
                left,
                tooltipEl.outerWidth(),
                $(window).width(),
            );

            tooltipEl.css({
                left: `${offsetLeft}px`,
                top: `${top - $(window).scrollTop()}px`,
            });

            this.attr('isActive', true);
        },
        hide() {
            this.attr('isActive', false);
        },
        remove() {
            can.remove(this.element);
            this.attr('element', null);
        },
    },
    events: {
        inserted($el) {
            this.viewModel.attr('element', $el);
            this.viewModel.attr('parentElement', $el.parent());
            this.appendToBody();
        },
        appendToBody() {
            if (this.element.parent().is('body')) {
                return;
            }

            this.element.appendTo(document.body);
        },
    },
});

function getOffsetLeft(offsetLeft, width, parentWidth) {
    const centerParentOffset =
        offsetLeft - (offsetLeft + width - parentWidth) - 10;
    if (offsetLeft + width / 2 >= parentWidth) {
        return centerParentOffset;
    }

    if (offsetLeft < width / 2) {
        if (offsetLeft + width >= parentWidth) {
            return centerParentOffset;
        }
        return offsetLeft;
    }

    return offsetLeft - width / 2;
}
